import styled from "styled-components";
import global from "../../../../global";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 50px;
  position: relative;
`;

export const ListContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 26px;
  margin-top: 16px;
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  width: 100%;

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    flex-direction: column;
    
    & > * {
      width: 100% !important;
      flex-shrink: 0;
    }

    & > button, 
    & > div > button {
      width: 100% !important;
      justify-content: center;
    }
  }
`;

export const SearchContainer = styled.form`
  display: flex;
  flex: 1; 
  min-width: 280px;
  height: 38px;
  box-sizing: border-box;

  input {
    flex: 1;
    height: 100%;
    padding: 0 16px;
    border: 1px solid var(--light-gray);
    border-right: none;
    border-radius: 20px 0 0 20px;
    font-size: 14px;
    color: var(--title);
    outline: none;
    transition: border-color 0.2s;
    box-sizing: border-box;

    &::placeholder {
      color: var(--gray);
    }

    &:focus {
      border-color: var(--fixit);
    }
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 100%;
    background: transparent;
    border: 1px solid var(--fixit);
    border-radius: 0 20px 20px 0;
    color: var(--fixit);
    cursor: pointer;
    transition: all 0.2s;
    box-sizing: border-box;

    &:hover {
      background: rgba(152, 53, 209, 0.05);
    }
    
    svg {
      width: 20px;
      height: 20px;
    }
  }
  
  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    width: 100%;
    min-width: unset;
    height: 38px !important;
    min-height: 38px !important;
    flex-shrink: 0;

    input, button {
      height: 38px !important;
      min-height: 38px !important;
    }
    
    button {
      width: 60px !important;
      min-width: 60px;
    }
  }
`;
